.tag {
  cursor: pointer;
}
